import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnapshotService } from '../Services/snapshot.service';

@Component({
  selector: 'app-outputview-pagination',
  templateUrl: './outputview-pagination.component.html',
  styleUrls: ['./outputview-pagination.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutputviewPaginationComponent implements OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();
  pageCounterSubject = this._configService.pageCounter;
  pageCounter = this._configService.x;
  @Output() paginationCounter = new EventEmitter();
  @Input() totalPages = 1000;

  constructor(public _configService: SnapshotService) {

  }
  ngOnChanges(changes: SimpleChanges) {
    // Use current value — no new subscription needed here
    this.pageCounter = this._configService.pageCounter.getValue();

    if (changes['totalPages']) {

      if (changes['totalPages'].currentValue == 1 || changes['totalPages'].currentValue == this.pageCounter) {
        this._configService.RightBtnDisable.next(true);
      }
      else {
        this._configService.RightBtnDisable.next(false);
      }
    }

  }


  ngOnInit(): void {
    this._configService.LeftBtnDisable.next(true);


    // -----------Initialize after creating variable of subject in service--------
    this._configService.LeftBtnDisable.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.disableLeftClick = value;
    });
    this._configService.RightBtnDisable.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.disableRightClick = value;
    });
    this._configService.pageCounter.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.pageCounter = value;
      if (value == 1) {
        this._configService.LeftBtnDisable.next(true);
      } else {
        this._configService.LeftBtnDisable.next(false);
      }
    });
    // --------------------------------------------------------------------------------

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  disableLeftClick = false;
  disableRightClick = false;
  onPageClick(side: string, event: Event) {
    if (side == 'left') {
      if (this.pageCounter == 2) {
        // this.disableLeftClick=true;
        this._configService.LeftBtnDisable.next(true)
        this.pageCounter--;
      }
      else {
        // this.disableLeftClick = false;
        this._configService.LeftBtnDisable.next(false)
        this._configService.RightBtnDisable.next(false)
        this.pageCounter--;
      }
      this.pageCounterSubject.next(this.pageCounter);
      this.paginationCounter.emit(this.pageCounter);
    }
    else if (side == 'right') {
      if (this.pageCounter > 0) {
        // this.disableLeftClick = false;
        this._configService.LeftBtnDisable.next(false)
      }

      if (this.pageCounter == (this.totalPages - 1)) {
        this._configService.RightBtnDisable.next(true)
      }
      this.pageCounter++;
      this.pageCounterSubject.next(this.pageCounter);
      this.paginationCounter.emit(this.pageCounter);
      ;
    }
  }
}
